// Canonical experiment status colors for consistent theming across the application
export const experimentColors = {
  pending: '#6B7280',    // Neutral gray (waiting)
  accepted: '#3B82F6',   // Blue (approved, ready)
  running: '#10B981',    // Green (active, in progress)
  finished: '#374151',   // Dark gray (completed)
  rejected: '#EF4444',   // Red (declined)
  manual_review: '#7C3AED' // Purple (AI suggestion, awaiting review)
};

// Helper function to get color by status
export const getExperimentStatusColor = (status) => {
  return experimentColors[status] || experimentColors.pending;
};

// Action button colors that align with their resulting status
export const experimentActionColors = {
  accept: experimentColors.accepted,   // Blue - leads to "accepted" status
  reject: experimentColors.rejected,   // Red - leads to "rejected" status
  begin: experimentColors.running     // Green - leads to "running" status
};